import React from 'react';
import { WebsiteDesignProps } from './types';
import {  Skull, Zap, Music } from 'lucide-react';
import { Button } from "@/components/ui/button";

const SkateCulture: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Grind School";

    return (
        <div className="bg-[#1a1a1a] text-white min-h-screen font-sans selection:bg-[#ff00ff]">
             {/* Concrete Texture */}
             <div className="fixed inset-0 pointer-events-none opacity-20" style={{backgroundImage: 'url("https://www.transparenttextures.com/patterns/concrete-wall-2.png")'}}></div>

             <nav className="p-6 relative z-20 flex justify-between items-center bg-black border-b-4 border-white transform -rotate-1 shadow-lg">
                 <div className="bg-white text-black px-4 py-1 text-2xl font-black uppercase tracking-tighter transform rotate-2 border-2 border-black">
                     {schoolName}
                 </div>
                 <div className="flex gap-4">
                     <Button className="bg-[#ff00ff] hover:bg-[#d100d1] text-white font-black uppercase border-2 border-white rounded-none transform rotate-1">
                         Drop In
                     </Button>
                 </div>
             </nav>

             <main className="container mx-auto px-6 py-12 relative z-10 overflow-hidden">
                 <div className="relative">
                     {/* Sticker Bomb Background */}
                     <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-400 rounded-full mix-blend-difference filter blur-3xl opacity-20"></div>
                     <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-400 rounded-full mix-blend-difference filter blur-3xl opacity-20"></div>

                     <div className="flex flex-col md:flex-row items-center gap-12">
                         <div className="md:w-1/2 relative">
                             <div className="bg-black border-4 border-white p-12 shadow-[8px_8px_0_#ff00ff]">
                                 <h1 className="text-6xl md:text-8xl font-black uppercase leading-[0.8] mb-6 italic">
                                     Shred <br/> The <br/> Norms.
                                 </h1>
                                 <p className="text-xl font-bold bg-white text-black inline-block p-2 transform -rotate-1">
                                     Education that doesn't fit in a box.
                                 </p>
                             </div>
                             {/* Sticker Decoration */}
                             <div className="absolute -top-6 -left-6 w-24 h-24 bg-yellow-400 rounded-full border-4 border-black flex items-center justify-center text-black font-black transform -rotate-12 shadow-lg">
                                 SICK!
                             </div>
                         </div>

                         <div className="md:w-1/2">
                             <div className="grid grid-cols-2 gap-4">
                                 <div className="bg-[#222] p-6 border-2 border-white transform rotate-2 hover:rotate-0 transition-transform">
                                     <Skull className="w-12 h-12 mb-4 text-[#ff00ff]" />
                                     <h3 className="font-black uppercase text-xl">No Fear</h3>
                                 </div>
                                 <div className="bg-[#222] p-6 border-2 border-white transform -rotate-2 hover:rotate-0 transition-transform mt-8">
                                     <Zap className="w-12 h-12 mb-4 text-yellow-400" />
                                     <h3 className="font-black uppercase text-xl">Energy</h3>
                                 </div>
                                 <div className="col-span-2 bg-white text-black p-6 border-4 border-[#ff00ff] transform rotate-1 text-center">
                                     <h2 className="text-4xl font-black uppercase italic">Join the Crew</h2>
                                     <Button className="mt-4 bg-black text-white w-full font-black uppercase hover:bg-[#333]">Sign Up</Button>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
             </main>
        </div>
    );
};

export default SkateCulture;
